<template>
	<div class="background" @click="">
		<div class="screen center" v-if="competition.state > 0 && competition.state < 3">
			<div class="screen-left">
				<img class="logo" :src="template.logo" alt="" />
				<div style="margin-top: 67px;" :style="template.title">当前级别</div>
				<div :style="template.titleEn">LEVEL</div>
				<div :style="template.number">{{ currentGrade.grade }}</div>
				<div style="margin-top: 87px;" :style="template.title">参赛人数</div>
				<div :style="template.titleEn">PLAYERS</div>
				<div :style="template.number">{{ competition.entryPeople - competition.outPeople }}/{{
            competition.entryPeople
          }}
				</div>

				<div style="margin-top: 97px;" :style="template.title">奖励人数</div>
				<div :style="template.titleEn">PRIZE PLAYER</div>
				<div :style="template.number">{{ competition.awardPeople }}</div>
			</div>
			<div class="screen-left-border"></div>
			<div class="competition">
				<div class="competition-title">{{ competition.title }}</div>
				<div class="competition-subhead">{{ competition.typeTitle }}</div>
				<div :style="template.timer">{{ competitionTime }}</div>
				<div class="base-score" style="margin-top: 72px;">
					<div class="base-score-left" :style="template.title">基础分</div>
					<div class="base-score-right" :style="template.number" style="font-size: 78px !important;">
						{{ currentGrade.baseScore }}/{{ currentGrade.halfBaseScore }}
					</div>
				</div>
				<div style="text-align: left;" :style="template.titleEn">BLINDS</div>
				<div class="base-score" style="margin-top: 36px;">
					<div class="base-score-left" :style="template.title">预置分</div>
					<div class="base-score-right" :style="template.number">{{ currentGrade.presetScore }}</div>
				</div>
				<div style="text-align: left;" :style="template.titleEn">ANTE</div>
				<div class="base-score" style="margin-top: 36px;">
					<div class="base-score-left" :style="template.title">下个级别</div>
					<div class="base-score-right" :style="template.number">{{ nextGrade.baseScore }}/{{
              nextGrade.halfBaseScore
            }}[{{ nextGrade.presetScore }}]
					</div>
				</div>
				<div style="text-align: left;" :style="template.titleEn">NEXT LEVEL</div>
			</div>
			<div class="screen-left-border"></div>
			<div class="screen-right">
				<div style="margin-top: 68px;" :style="template.title">截止报名</div>
				<div :style="template.titleEn">ENTRY ENDS IN</div>
				<div :style="template.number">{{ closeApply }}</div>
				<div style="margin-top: 82px;" :style="template.title">下次休息</div>
				<div :style="template.titleEn">NEXT BREAK IN</div>
				<div :style="template.number">{{ restTime }}</div>
				<div style="margin-top: 72px;" :style="template.title">平均记分牌</div>
				<div :style="template.titleEn">AVG.CHIPS</div>
				<div :style="template.number">{{ competition.avgScoreBoard }}</div>
				<div style="margin-top: 66px;" :style="template.title">总计分牌</div>
				<div :style="template.titleEn">TOTAL CHIPS</div>
				<div :style="template.number">{{ competition.scoreBoard }}</div>
			</div>
			<div class="apply" v-if="currentGrade.apply">接受报名</div>
			<div class="apply" v-else style="color: #FFFFFF; background: #E62929">截止报名</div>
			<div class="nowTime" :style="template.number">{{ nowTime }}</div>
		</div>
		<div class="not-start center" v-if="competition.state === 0">
			<img class="not-start-logo" :src="template.logo" alt="" />
			<div class="not-start-title">{{ competition.title }}</div>
			<div class="not-start-hint">比赛未开始</div>
			<div class="not-start-hint-en bold">THE GAME DID NOT START</div>
			<div class="not-start-timer">{{ competitionTime }}</div>
		</div>
		<div id="competition-end" v-if="competition.state === 3" :style="endStyle"></div>
		<div class="competition-stop center" v-if="(dialogVisible || competition.state === 2) && !operateFlag">
			<div class="competition-stop-title">比赛暂停</div>
			<div class="competition-stop-title-en bold">PAUSE</div>
		</div>
		<div class="competition-stop center" style="color: #00A662" v-if="currentGrade.rest && !operateFlag">
			<div class="competition-stop-title">休息中</div>
			<div class="competition-stop-title-en bold">{{ competitionTime }}</div>
		</div>
		<div class="bottom bold" v-if="competition.state !== 3">{{ prompt }}</div>
		<audio ref="music" preload="auto" @ended="musicEnd">
			<source src="https://img.holyiac.com/images/audio/mp3/time-left.mp3" type="audio/mpeg">
		</audio>
		<audio ref="startMusic" preload="auto" @ended="startMusicEnd">
			<source src="https://img.holyiac.com/images/audio/mp3/time-left.mp3" type="audio/mpeg">
		</audio>
		<audio ref="restEnd" preload="auto" @ended="restEnd">
			<source src="https://img.holyiac.com/images/audio/mp3/time-left.mp3" type="audio/mpeg">
		</audio>
		<audio ref="start" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/start.mp3" type="audio/mpeg">
		</audio>
		<audio ref="rest" preload="auto">
			<source src="https://img.holyiac.com/images/audio/voicePacket/rest.mp3" type="audio/mpeg">
		</audio>
		<audio ref="broadcast" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/broadcast.mp3" type="audio/mpeg">
		</audio>
		<audio ref="one" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/一.mp3" type="audio/mpeg">
		</audio>
		<audio ref="two" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/二.mp3" type="audio/mpeg">
		</audio>
		<audio ref="three" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/三.mp3" type="audio/mpeg">
		</audio>
		<audio ref="four" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/四.mp3" type="audio/mpeg">
		</audio>
		<audio ref="five" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/五.mp3" type="audio/mpeg">
		</audio>
		<audio ref="six" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/六.mp3" type="audio/mpeg">
		</audio>
		<audio ref="seven" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/七.mp3" type="audio/mpeg">
		</audio>
		<audio ref="eight" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/八.mp3" type="audio/mpeg">
		</audio>
		<audio ref="nine" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/九.mp3" type="audio/mpeg">
		</audio>
		<audio ref="ten" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/十.mp3" type="audio/mpeg">
		</audio>
		<audio ref="hundred" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/百.mp3" type="audio/mpeg">
		</audio>
		<audio ref="thousand" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/千.mp3" type="audio/mpeg">
		</audio>
		<audio ref="myriad" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/万.mp3" type="audio/mpeg">
		</audio>
		<audio ref="preset" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/preset.mp3" type="audio/mpeg">
		</audio>
		<audio ref="manage" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/manage.mp3" type="audio/mpeg">
		</audio>
		<audio ref="service" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/service.mp3" type="audio/mpeg">
		</audio>
		<audio ref="seat" preload="auto">
			<source src="https://img.holyiac.com/images/audio/voicePacket/end.mp3" type="audio/mpeg">
		</audio>
		<audio ref="competitionFive" preload="auto" @ended="competitionFiveEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/competition-five.mp3" type="audio/mpeg">
		</audio>
		<audio ref="competitionThree" preload="auto">
			<source src="https://img.holyiac.com/images/audio/voicePacket/competition-three.mp3" type="audio/mpeg">
		</audio>
		<audio ref="continue" preload="auto" @ended="broadcastEnd">
			<source src="https://img.holyiac.com/images/audio/voicePacket/continue.mp3" type="audio/mpeg">
		</audio>
		<div class="competition-list" v-if="competitionOption">
			<div class="competition-list-title">请选择赛事</div>
			<ul>
				<li :class="item.active ? 'active' : ''" v-for="item in competitionList"
					@click="connectCompetition(item.id)">{{ item.title }}
				</li>
			</ul>
		</div>
		<div class="competition-stop center" v-if="operateFlag" style="top: -400px;">
			<div class="competition-stop-title" style="font-size: 130px;">同步手牌阶段</div>
			<div class="competition-stop-title-en bold">{{syncHandText}}</div>
		</div>
	</div>
</template>

<script>
	import {
		formatDate,
		timeToMinute
	} from '@/utils/date'
	import {
		getTemplate,
		competitionList
	} from '@/api/screen'

	const defaultCompetition = {
		id: null,
		title: null,
		typeTitle: null,
		screenNum: null,
		awardPeople: 0,
		entryPeople: 0,
		outPeople: 0,
		state: 0,
		scoreBoard: 0,
		avgScoreBoard: 0,
		startTime: null,
		prompt: null,
		gradeList: [],

	}

	const defaultGrade = {
		id: null,
		grade: 1,
		baseScore: 1,
		halfBaseScore: 1,
		presetScore: 1,
		takeTime: 1,
		residueTime: 1,
		rest: false,
		apply: true,
	}
	const params = new URLSearchParams(window.location.search);
	export default {
		name: 'screen',
		props: {
			msg: String
		},
		data() {
			return {
				operateFlag: false,
				syncHandText: '',
				dialogVisible: false,
				competitionOption: false,
				//当前时间
				nowTime: "00:00:00",
				//赛事倒计时
				competitionTime: "00:00",
				//休息时间
				restTime: "无",
				//剩余秒数
				restTimeSeconds: 0,
				//赛事定时器id
				competitionTimerId: null,
				//赛事信息
				competition: Object.assign({}, defaultCompetition),
				//当前等级
				currentGrade: Object.assign({}, defaultGrade),
				//下个等级
				nextGrade: Object.assign({}, defaultGrade),
				//休息等级
				currentRestGrade: Object.assign({}, defaultGrade),
				//连接定时器id
				connectId: null,
				//结束报名
				closeApply: null,
				prompt: "绿色竞技，禁止赌博",
				audioState: false,
				//赛事id
				competitionId: null,
				//赛事列表
				competitionList: [],
				checkCompetition: null,
				appId: null,
				template: {
					logo: null,
					number: null,
					title: null,
					titleEn: null,
					timer: null,
					webNumber: null,
					webTitle: null,
					webTitleEn: null,
					webTimer: null,
				},
				music: false,
				endStyle: null,
				presetScoreFlag: false,
				videoText: "",
				nextFlag: false,
				presetFlag: false,
				callFlag: false,
				restFlag: false,
				competitionFive: 0,

			}
		},
		mounted() {
			this.competitionId = params.get("id");
			this.appId = params.get("appid");
			this.startTimer();
			this.getTemplate();
			if (this.competitionId != null) {
				this.init()
			} else {
				this.getCompetitionList();
				this.competitionOption = true;
			}
			window.addEventListener("keydown", this.handleKeydown);
		},
		filters: {
			formatCreateTime(time) {
				let date = new Date(time);
				return formatDate(date, 'hh:mm:ss')
			},
		},
		methods: {
			init: function() {
				if (typeof(WebSocket) === "undefined") {
					alert("您的浏览器不支持socket")
				} else {
					// 实例化socket
					this.socket = new WebSocket("wss://api.holyiac.com/socket-service/ws/" +
						// this.socket = new WebSocket("ws://192.168.3.55:8000/socket-service/ws/" +
						this.appId + "/" + this.competitionId + "-" + parseInt((Math.random() * 9999).toString()))
					// 监听socket连接
					this.socket.onopen = this.open
					// 监听socket错误信息
					this.socket.onerror = this.error
					// 监听socket消息
					this.socket.onmessage = this.getMessage
					this.socket.close = this.close;
					if (!this.music) {
						this.$refs.music.play();
					}
				}
			},
			open: function() {
				if (this.connectId != null) {
					clearInterval(this.connectId);
				}
				this.connectId = setInterval(() => {
					if (this.socket.readyState === WebSocket.OPEN) {
						this.socket.send("ping");
					} else {
						clearInterval(this.connectId);
						this.init();
					}
				}, 10000);
			},
			error: function() {
				this.connectId = setInterval(() => {
					window.location.reload();
				}, 5000);
			},
			//接收服务器发来的消息
			getMessage: function(e) {
				let result = JSON.parse(e.data);
				if (result.key === "pong") {
					return;
				}
				if (result.key === "syncHandStart") {
					this.operateFlag = true
					this.syncHandText = result.value;
					return;
				}
				if (result.key === "syncHandEnd") {
					this.operateFlag = false
					return;
				}
				if (result.key === "refresh") {
					window.location.reload();
					return;
				}
				if (result.key === "error") {
					this.competitionTime = result.value;
					return;
				}
				if (result.key === "call") {
					this.$refs.service.play();
					this.videoText = this.numberToChinese(result.value)
					this.callFlag = true;
					return;
				}
				if (result.key === "help") {
					this.$refs.manage.play();
					this.videoText = this.numberToChinese(result.value)
					this.callFlag = true;
					return;
				}
				if (result.key === "competition") {
					this.competition = result.value;
					//当前等级
					this.currentGrade = this.getCurrentGrade(this.competition.gradeList);
					//进入休息时间播报
					if (this.currentGrade.rest && !this.restFlag && !this.operateFlag) {
						this.restFlag = true;
						this.$refs.rest.play();
					}
					if (!this.currentGrade.rest) {
						this.restFlag = false;
					}
					//下一等级
					this.nextGrade = this.getNextGrade(this.competition.gradeList);
					//赛事状态大于0则清除开始倒计时
					if (this.competitionTimerId != null && this.competition.state > 0) {
						clearInterval(this.competitionTimerId);
						this.competitionTimerId = null;
					}
					//获取休息等级
					this.restGrade = this.getRestGrade(this.competition.gradeList);
					//休息时间定时器
					if (this.restGrade != null && this.restGrade.residueTime > 0 && this.competition.state > 0 && this
						.restTimeSeconds > 0) {
						let date = new Date(new Date().getTime() + this.restTimeSeconds * 1000);
						this.restTime = timeToMinute(date, true);
					} else {
						this.restTime = "无";
					}
					//赛事底部提示语
					if (this.competition.prompt != null) {
						this.prompt = this.competition.prompt;
					}
					//距赛事开始计时器
					if (this.competition.state === 0 && this.competition.id != null) {
						let that = this;
						that.competitionTimerId = setInterval(() => {
							that.competitionTime = timeToMinute(new Date(this.competition.startTime), true);
							if (that.competitionTime === "00:00:03") {
								that.$refs.startMusic.play();
							}
							if (that.competitionTime === "00:05:01") {
								that.$refs.competitionFive.play();
							}
							if (that.competitionTime === "00:03:01") {
								that.$refs.competitionThree.play();
							}
							if (that.competitionTime === "00:00:00") {
								clearInterval(that.competitionTime)
							}
						}, 1000);
					} else {
						//赛事时间
						this.competitionTime = timeToMinute(new Date(new Date().getTime() + this.currentGrade
							.residueTime * 1000), false);
						clearInterval(this.competitionTimerId)
					}
					if (this.competition.state === 1) {
						this.dialogVisible = false;
					}
					if (this.competition.closeApply) {
						this.closeApply = this.competition.entryPeople + "/" + this.competition.entryLimitPeople;
					} else {
						this.closeApply = timeToMinute(new Date(new Date().getTime() + this.getCloseApply(this
							.competition.gradeList) * 1000), true);
					}
					if (this.currentGrade.residueTime === 3) {
						if (this.currentGrade.rest) {
							this.$refs.restEnd.play();
						} else {
							this.playMusic();
						}
					}
				}
			},
			restEnd() {
				//休息时间结束播报
				this.videoText = this.numberToChinese(this.currentGrade.baseScore)
				this.$refs.continue.play();
			},
			competitionFiveEnd() {
				if (this.competitionFive == 0) {
					this.competitionFive = this.competitionFive + 1
					this.$refs.competitionFive.play();
				}
			},
			startMusicEnd() {
				this.videoText = this.numberToChinese(this.currentGrade.baseScore)
				this.$refs.start.play();
			},
			playMusic() {
				this.$refs.music.play();
			},
			getCloseApply(gradeList) {
				let residueSeconds = 0;
				for (let i = 0; i < gradeList.length; i++) {
					if (gradeList[i].apply) {
						residueSeconds = residueSeconds + gradeList[i].residueTime;
					}
				}
				return residueSeconds;
			},
			getRestGrade(gradeList) {
				this.restTimeSeconds = 0;
				for (let i = 0; i < gradeList.length; i++) {
					this.restTimeSeconds = this.restTimeSeconds + gradeList[i].residueTime;
					if (gradeList[i].rest && gradeList[i].residueTime > 0 && gradeList[i].id !== this.currentGrade.id) {
						this.restTimeSeconds = this.restTimeSeconds - gradeList[i].residueTime;
						return gradeList[i];
					} else {
						this.restGrade = Object.assign({}, defaultGrade);
					}
				}
				return null;
			},
			getCurrentGrade(gradeList) {
				for (let i = 0; i < gradeList.length; i++) {
					if (gradeList[i].residueTime > 0) {
						return gradeList[i];
					}
				}
				return null;
			},
			getNextGrade(gradeList) {
				for (let i = 0; i < gradeList.length; i++) {
					if (gradeList[i].grade === this.currentGrade.grade + 1) {
						return gradeList[i];
					}
					if (gradeList.length === i + 1 && gradeList[i].grade !== this.currentGrade.grade + 1) {
						return Object.assign({}, defaultGrade);
					}
				}
				return null;
			},
			connectCompetition(id) {
				this.playMusic();
				window.location.href = "/?appid=" + this.appId + "&id=" + id + "&type=web"
			},
			updateState() {
				if(this.operateFlag){
					return;
				}
				//暂停/继续赛事
				if (this.competition.state > 0 && this.competition.state < 3 && this.competitionId != null && !this
					.currentGrade.rest) {
					this.socket.send("updateState");
					this.dialogVisible = true;
				}
			},
			handleKeydown(e) {
				if (e.key === "Enter") {
					this.updateState();
					if (this.checkCompetition != null) {
						window.location.href = "/?appid=" + this.appId + "&id=" + this.competitionId + "&type=web"
					}
				}
				if (e.key === "ArrowUp") {
					for (let i = 0; i < this.competitionList.length; i++) {
						if (i === 0 && this.competitionList[i].active) return;
						if (this.competitionList[i].active) {
							this.checkCompetition = this.competitionList[i - 1];
							this.competitionList[i - 1].active = true;
						}
						this.competitionList[i].active = this.checkCompetition.id === this.competitionList[i].id;
					}
				}
				if (e.key === "ArrowDown") {
					for (let i = 0; i < this.competitionList.length; i++) {
						if (this.competitionList.length - 1 === i && this.competitionList[i].active) return;
						if (this.competitionList[i].active) {
							this.checkCompetition = this.competitionList[i + 1];
						}
						if (this.checkCompetition != null) {
							this.competitionList[i].active = this.checkCompetition.id === this.competitionList[i].id;
						}
					}
					if (this.checkCompetition == null) {
						this.competitionList[0].active = true;
						this.checkCompetition = this.competitionList[0];
					}
				}
			},
			//给服务器发消息的方法
			send: function() {},
			//连接关闭
			close: function() {},
			startTimer: function() {
				// 系统时间计时器
				setInterval(() => {
					this.nowTime = formatDate(new Date(), 'hh:mm:ss');
				}, 1000);
			},
			getTemplate() {
				getTemplate({
					appId: this.appId
				}).then(response => {
					let type = params.get("type");
					this.template = response.data;
					if (type === "web") {
						this.template.title = this.template.webTitle;
						this.template.titleEn = this.template.webTitleEn;
						this.template.number = this.template.webNumber;
						this.template.timer = this.template.webTimer;
					}
					document.getElementById("app").style.backgroundImage = "url(" + this.template.background + ")";
					this.endStyle = "background-image: url(" + this.template.champion + ")"
				})
			},
			getCompetitionList() {
				competitionList({
					appId: this.appId
				}).then(response => {
					if (response.data != null) {
						response.data.forEach(item => {
							item.active = false;
							this.competitionList.push(item)
						})
					}
				})
			},
			musicEnd() {
				if (!this.music) {
					this.music = true;
				} else {
					if (!this.currentGrade.rest) {
						this.$refs.broadcast.play();
						this.videoText = this.numberToChinese(this.currentGrade.baseScore)
					}
				}
				// console.log(this.videoText)
			},
			broadcastEnd() {
				// console.log(this.numberToChinese(this.currentGrade.halfBaseScore))
				// console.log(this.numberToChinese(this.currentGrade.presetScore))
				// console.log(this.numberToChinese(3500))
				// console.log(this.numberToChinese(30000))
				if (this.callFlag) {
					if (this.nextFlag) {
						this.callFlag = false;
						this.nextFlag = false;
						this.$refs.seat.play();
						return;
					}
					let name = this.videoText.substring(0, 1);
					if (this.videoText.length == 1) {
						this.nextFlag = true;
					} else {
						this.videoText = this.videoText.substring(1, this.videoText.length);
					}
					// console.log("预置分:", name)
					this.broadcast(name);
					return
				}
				if (this.presetFlag) {
					if (this.nextFlag) {
						this.presetFlag = false;
						this.nextFlag = false;
						return;
					}
					// console.log(this.videoText)
					let name = this.videoText.substring(0, 1);
					if (this.videoText.length == 1) {
						this.nextFlag = true;
					} else {
						this.videoText = this.videoText.substring(1, this.videoText.length);
					}
					// console.log("预置分:", name)
					this.broadcast(name);
				} else {
					if (this.nextFlag) {
						console.log(this.currentGrade.presetScore)
						if (this.currentGrade.presetScore == 0) {
							this.nextFlag = false;
							return;
						}
						this.videoText = this.numberToChinese(this.currentGrade.presetScore);
						// console.log("进入预置分")
						this.presetFlag = true;
						this.nextFlag = false;
						this.$refs.preset.play();
						return;
					}
					// console.log(this.videoText)
					let name = this.videoText.substring(0, 1);
					if (this.presetScoreFlag) {
						if (this.videoText.length == 1) {
							this.presetScoreFlag = false;
							this.nextFlag = true
						} else {
							// console.log((this.videoText))
							// name = this.videoText.substring(0, 1);
							this.videoText = this.videoText.substring(1, this.videoText.length);
							// this.presetScore = 'https://img.holyiac.com/images/audio/voicePacket/'+ name +'.mp3'
						}
						// this.$refs.presetScore.play();

					} else {
						// console.log("基础分:", name)
						if (this.videoText.length == 1) {
							this.videoText = this.numberToChinese(this.currentGrade.halfBaseScore);
							this.presetScoreFlag = true;
						} else {
							this.videoText = this.videoText.substring(1, this.videoText.length);
						}
					}
					this.broadcast(name);
				}
				// this.presetScore = 'https://img.holyiac.com/images/audio/voicePacket/' + name + '.mp3'
			},

			seatEnd() {

			},

			broadcast(title) {
				if (title == '一') {
					this.$refs.one.play();
				}
				if (title == '二') {
					this.$refs.two.play();
				}
				if (title == '三') {
					this.$refs.three.play();
				}
				if (title == '四') {
					this.$refs.four.play();
				}
				if (title == '五') {
					this.$refs.five.play();
				}
				if (title == '六') {
					this.$refs.six.play();
				}
				if (title == '七') {
					this.$refs.seven.play();
				}
				if (title == '八') {
					this.$refs.eight.play();
				}
				if (title == '九') {
					this.$refs.nine.play();
				}
				if (title == '十') {
					this.$refs.ten.play();
				}
				if (title == '百') {
					this.$refs.hundred.play();
				}
				if (title == '千') {
					this.$refs.thousand.play();
				}
				if (title == '万') {
					this.$refs.myriad.play();
				}
			},
			numberToChinese(num) {
				if (num == 100000) {
					return '十万'
				}
				if (num == 1000000) {
					return '一百万'
				}
				const chineseNumbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
				const units = ['', '十', '百', '千', '万', '十万', '百万', '千万'];
				let result = '';
				num = num.toString();
				for (let i = 0; i < num.length; i++) {
					if (chineseNumbers[num[i]] != '') {
						result += chineseNumbers[num[i]] + units[num.length - i - 1];
					}

				}
				if (num.length == 6 && result.length > 3) {
					result = result.replace("万", "")
				}
				// console.log(result)
				if (result.length == 2 && num > 10 && num < 20) {
					result = "十" + result.substring(1, result.length)
				}
				return result;
			}
		}
	}
</script>

<style scoped>
	.competition-list li {
		height: 80px;
		line-height: 80px;
		font-size: 32px;
		border-top: 1px solid #FCE290;
	}

	.competition-list li:hover {
		background-color: #FCE290;
		color: #000000;
		cursor: pointer;
	}

	.active {
		background-color: #FCE290;
		color: #000000;
	}

	.competition-list ul {
		margin-top: 30px;
		overflow-y: scroll;
		height: 400px;
		scrollbar-width: thin;
	}

	::-webkit-scrollbar {
		display: none;
	}

	.competition-list-title {
		font-size: 48px;
		margin-top: 30px;
		line-height: 34px;
	}

	.competition-list {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		width: 600px;
		height: 500px;
		border: 1px solid #FCE290;
		background-color: rgba(0, 0, 0, 0.8);
		color: #FFFFFF;
		text-align: center;
		font-family: PingFang SC;
		border-radius: 10px;
	}

	@keyframes marquee {
		0% {
			transform: translateX(0);
		}

		100% {
			transform: translateX(-100%);
		}
	}

	.nowTime {
		font-size: 30px !important;
		line-height: 28px !important;
		position: absolute;
		top: 50px;
		right: 133px;
	}

	.competition-stop-title-en {
		font-size: 97px;
		font-family: PingFang SC;
		line-height: 97px;
		margin-top: 46px;
	}

	.competition-stop-title {
		font-size: 180px;
		font-family: PingFang SC;
		line-height: 180px;
		margin-top: 84px;
	}

	.competition-stop {
		width: 823px;
		height: 458px;
		color: #E62929;
		background-color: rgba(0, 0, 0, 0.8);
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		text-align: center;
		border-radius: 5px;
	}

	.not-start-timer {
		width: 100%;
		font-size: 278px;
		font-weight: 800;
		color: #E62929;
		line-height: 278px;
		position: absolute;
		bottom: 200px;
	}

	.not-start-hint-en {
		width: 100%;
		font-size: 46px;
		font-family: PingFang SC;
		line-height: 46px;
		position: absolute;
		top: 520px;
	}

	.not-start-hint {
		width: 100%;
		font-size: 180px;
		font-family: PingFang SC;
		line-height: 180px;
		position: absolute;
		top: 296px;
		letter-spacing: 20px;
	}

	.not-start-title {
		width: 100%;
		position: absolute;
		top: 114px;
		height: 50px;
		font-size: 50px;
		font-family: PingFang SC;
		line-height: 50px;
	}

	.not-start-logo {
		position: absolute;
		top: 72px;
		left: 259px;
		width: 172px;
		height: 190px;
	}

	#competition-end {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.apply {
		width: 200px;
		height: 70px;
		line-height: 70px;
		background: linear-gradient(90deg, #4CCB37 0%, #028007 100%);
		position: absolute;
		bottom: 90px;
		right: 444px;
		text-align: center;
		font-size: 41px;
		font-family: PingFang SC;
		border-radius: 5px;
	}

	.bottom {
		font-size: 42px;
		font-family: PingFang SC;
		position: absolute;
		bottom: 10px;
		right: 0;
		left: 0;
		text-align: right;
		color: #FFFFFF;
		letter-spacing: 10px;
		white-space: nowrap;
		display: inline-block;
		animation: marquee 30s linear infinite;
	}


	.base-score-right {
		float: right;
		line-height: 56px !important;
		margin-top: 0 !important;
	}

	.base-score-left {
		font-size: 46px !important;
		line-height: 50px !important;
		float: left;
	}

	.base-score {
		overflow: hidden;
		margin-top: 20px;
		line-height: 80px;
		height: 60px;
	}

	.competition-subhead {
		font-size: 40px;
	}

	.competition-title {
		height: 48px;
		font-size: 50px;
		line-height: 33px;
	}

	.competition {
		float: left;
		width: 1022px;
		margin: 72px 60px 0 60px;
	}

	.screen-left-border {
		float: left;
		width: 5px;
		height: 842px;
		background-image: linear-gradient(to top, #033661 0%, #FFFFFF 50%, #001925 100%);
		margin-top: 123px;
	}

	.logo {
		width: 172px;
	}

	.screen-left,
	.screen-right {
		margin-top: 88px;
		float: left;
		width: 384px;
	}

	.bold {
		font-weight: bold;
	}

	.screen,
	.not-start {
		overflow: hidden;
		width: 1920px;
		height: 1080px;
		min-height: 1080px;
		letter-spacing: 2px;
		color: #FFFFFF;
		position: relative;
		text-align: center;
	}

	.background {
		height: 100%;
		width: 100%;
		min-width: 1920px;
		min-height: 1080px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
	}

	ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	@font-face {
		font-family: DIN-Bold;
		src: url("../../static/fonts/DIN-Bold.otf");
	}

	@font-face {
		font-family: FuturaNo2DMed;
		src: url("../../static/fonts/FuturaNo2D-Med.ttf");
	}

	@font-face {
		font-family: PingFang SC;
		src: url("../../static/fonts/PingFang Bold.ttf");
	}

	@font-face {
		font-family: 微软雅黑;
		src: url("../../static/fonts/微软雅黑.ttf");
	}
</style>